import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f1ddd93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-dialog" }
const _hoisted_2 = { class: "buttom-row group-top" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "contact-list" }
const _hoisted_6 = { class: "header-contact" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-angle-up fas" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-angle-down fas" }, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["title"]

import { ref, onMounted, reactive } from "vue";
import {
  hasDuplicate,
  notifyValidateEmail,
  notifyValidateWhatsapp,
  validateEmail,
} from "@/utils/validate.util";
import type { FormInstance, FormRules } from "element-plus";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { deleteContacts, getContacts, postContacts } from "@/service/contact.service";
import { RootState } from "@/types/state.type";
import { Contact, ContactForm } from "@/types/contact";
import { ElMessage, ElMessageBox } from "element-plus";
import { AppError } from "@/types/app.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useI18n();
const store = useStore<RootState>();

const limitContacts = 10;
const ruleFormRef = ref<FormInstance>();

const contacts = ref<ContactForm[]>([]);
const checkedContacts = ref([] as string[]);
const deleteIds = ref([] as number[]);
const rules = reactive<FormRules>({
  email: [{ validator: notifyValidateEmail, trigger: "blur" }],
  whatsapp: [
    {
      validator: notifyValidateWhatsapp,
      trigger: "blur",
    },
  ],
});

onMounted(async () => {
  const contactsList = store.state.auth.user?.id
    ? await getContacts(store.state.auth.user?.id)
    : ([] as Contact[]);
  initializeContacts(contactsList);
});

const initializeContacts = (contactsList: Contact[]) => {
  let cont = 0;
  contactsList.forEach((_) => {
    contacts.value.push({
      ..._,
      index: ++cont,
      isExpanded: false,
    });
  });
};
/**
 * Botones superiores
 */
const deleteItem = () => {
  checkedContacts.value.forEach((element) => {
    const index = contacts.value.findIndex((_) => _.name === element);
    if (index >= 0) {
      // Guardar id si ya existía en base de datos
      const contact = contacts.value[index];
      if (contact?.id !== undefined) {
        deleteIds.value.push(contact.id);
      }
      contacts.value.splice(index, 1);
    }
  });

  checkedContacts.value = [] as string[];
};

function addItem() {
  contacts.value.forEach((contact) => (contact.isExpanded = false)); // Contraer todos
  const lastIndex =
    contacts.value && contacts.value.length === 0
      ? 0
      : contacts.value[contacts.value.length - 1]?.index
      ? contacts.value[contacts.value.length - 1].index
      : contacts.value.length;
  const newIndex = lastIndex + 1;
  if (contacts.value.length === limitContacts) {
    ElMessage.warning(
      `${t("warning.notMore", {
        type: `${t("label.contacts")}`.toLowerCase(),
        limit: limitContacts,
      })}`
    );
  } else {
    contacts.value.push({
      name: `${t("label.contact")} ${newIndex}`,
      email: null,
      phone: null,
      index: newIndex,
      isExpanded: true, // Nuevo contacto comienza expandido
    });
  }
}

/**
 * Seleccionar elementos
 */

const toggleContactExpanded = (num: number) => {
  const index = contacts.value.findIndex((_) => _.index === num);
  if (index >= 0) {
    contacts.value[index].isExpanded = !contacts.value[index].isExpanded;
  }
};

const handleCheckAllChange = () => {
  if (checkedContacts.value.length !== contacts.value.length) {
    checkedContacts.value = [] as string[];
    contacts.value.forEach((element) => {
      checkedContacts.value.push(element.name);
    });
  } else {
    checkedContacts.value = [] as string[];
  }
};

/**
 * Funciones botones inferiores
 */

const deleteContactsIds = async () => {
  if (deleteIds.value.length > 0) {
    await deleteContacts(deleteIds.value);
  }
};

const saveList = async () => {
  if (contacts.value.length > 0) {
    const contactsSave: Contact[] = contacts.value.map((_) => {
      if (_.email && !validateEmail(_.email)) {
        throw new Error(`${t("validation.notCorrect", { item: "email" })}`);
      }
      if (!_.email && !_.phone) {
        ElMessage.error(`${t("error.contact_validation")}`);
        throw new Error("Error");
      }

      return {
        id: _.id || undefined,
        name: _.name,
        email: _.email,
        phone: _.phone,
        user: store.state.auth.user?.id,
      };
    });

    await postContacts(contactsSave);
  }
};

const getContent = () => {
  return checkedContacts.value.length !== contacts.value.length
    ? `${t("btn.selectAll")}`
    : "Desmarcar todos";
};

const saveChanges = async () => {
  if (hasDuplicate(contacts.value, "name") || hasDuplicate(contacts.value, "email")) {
    throw new Error(AppError.DUPLICATE);
  }

  try {
    const confirm = await ElMessageBox.confirm(
      `${t("confirm.createContact")}`,
      `${t("label.warning")}`,
      {
        confirmButtonText: "OK",
        cancelButtonText: `${t("btn.cancel")}`,
        type: "warning",
      }
    );

    if (confirm) {
      await deleteContactsIds();
      await saveList();
      ElMessage.success(`${t("success.user")}`);
      return false; // Operación exitosa
    }
  } catch (error) {
    return true; // Se canceló la acción o hubo un error
  }

  return true;
};

expose({
  saveChanges,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: getContent(),
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleCheckAllChange,
            disabled: contacts.value && contacts.value.length === 0,
            circle: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("em", {
                class: _normalizeClass(
              contacts.value && checkedContacts.value.length !== contacts.value.length
                ? 'el-icon el-icon-check fas'
                : 'el-icon el-icon-minus fas'
            )
              }, null, 2)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: _ctx.$t('btn.delete'),
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn-group",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteItem())),
            disabled: contacts.value && (contacts.value.length === 0 || checkedContacts.value.length === 0),
            circle: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("em", {
                class: "el-icon el-icon-trash fas",
                title: _ctx.$t('btn.delete')
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: _ctx.$t('btn.create'),
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn-group",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addItem())),
            circle: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("em", {
                class: "el-icon el-icon-plus fas",
                title: _ctx.$t('btn.create')
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _createVNode(_component_el_scrollbar, { height: "400px" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_checkbox_group, {
            modelValue: checkedContacts.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkedContacts).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (contact) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  key: contact.id,
                  class: "contact-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_checkbox, {
                        label: contact.name,
                        value: contact.name
                      }, null, 8, ["label", "value"]),
                      (!contact.isExpanded)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: ($event: any) => (toggleContactExpanded(contact.index)),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            onClick: ($event: any) => (toggleContactExpanded(contact.index)),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]),
                    (contact.isExpanded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("em", {
                            class: "el-icon el-icon-edit fas",
                            title: _ctx.$t('btn.edit')
                          }, null, 8, _hoisted_10),
                          _createVNode(_component_el_form, {
                            ref_for: true,
                            ref_key: "ruleFormRef",
                            ref: ruleFormRef,
                            model: contact,
                            rules: _unref(rules),
                            "label-width": "100px",
                            class: "demo-ruleForm"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.name')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: contact.name,
                                    "onUpdate:modelValue": ($event: any) => ((contact.name) = $event),
                                    placeholder: _ctx.$t('label.name'),
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.email'),
                                prop: "email"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: contact.email,
                                    "onUpdate:modelValue": ($event: any) => ((contact.email) = $event),
                                    placeholder: _ctx.$t('label.email'),
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.phone'),
                                prop: "phone"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: contact.phone,
                                    "onUpdate:modelValue": ($event: any) => ((contact.phone) = $event),
                                    placeholder: _ctx.$t('label.phone'),
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1032, ["model", "rules"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})